
const DeviceChartColors = {
  "Ambi::Device": "#6066FF",
  "FuturePoint::Device": "#FF6060",
  "Oadr::Device": "#14b739"
}
export default DeviceChartColors